import React from 'react';
import TrademarkLogo, { tmFontSize } from './TrademarkLogo';
import { useNavigate } from 'react-router-dom'; // NEW IMPORT
//using the image because I don't want this logo to scale like the other one does

const AuthShell = ({ title, children }) => {
  const navigate = useNavigate(); // INITIALIZE HOOK
  const shellStyle = {
    backgroundColor: '#D1DEE6',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Inter', sans-serif"
  };

  const whiteBoxStyle = {
    backgroundColor: '#FFFFFF',
    borderRadius: '25px',
    padding: '50px',
    width: '90%',
    maxWidth: '450px', //max width 225 seems pretty ok. Might just need to also scale down text size as well as logo to make this work
    boxShadow: '0 8px 30px rgba(0,0,0,0.05)',
    textAlign: 'center',
    boxSizing: 'border-box',
  };

  const titleStyle = {
    color: '#2B4B6F',
    // 32px caused "Sign in to an existing account" to wrap inside the 450px-
    // max-width white box (350px inner after 50px padding each side). Clamp
    // keeps the title prominent on wide viewports while shrinking enough on
    // narrow ones to keep it on a single line.
    fontSize: 'clamp(18px, 4vw, 22px)',
    marginBottom: '30px',
    fontWeight: '600',
    whiteSpace: 'nowrap'
  };

  return (
    <div style={shellStyle}>
      <style>{`
        @media screen and (min-width: 300px) and (max-width: 600px) {
          .auth-logo {
            margin: 15px 0;
          }
          .auth-logo img {
            width: 120px !important;
          }
          .auth-logo [data-testid="logo-tm"] {
            font-size: 12px !important;
          }
          .auth-title {
            margin-bottom: 20px !important;
          }
        }
      `}</style>

      {/*Logo stays constantly above the box and is also a source of escape back to the home page*/}
      <TrademarkLogo
        imgStyle={{ width: '180px', cursor: 'pointer' }}
        imgProps={{ onClick: () => navigate('/') }}
        tmSize={`${tmFontSize({ width: 180 })}px`}
        wrapperStyle={{ marginBottom: '20px' }}
        className="auth-logo"
      />
      
      <div style={whiteBoxStyle}>
        {/* The Title changes based on the page */}
        <h2 className="auth-title" style={titleStyle}>{title}</h2>
        
        {/*Unique form content is injected here*/}
        {children}
      </div>
    </div>
  );
};

export default AuthShell;